import axios, { AxiosInstance } from 'axios';

const ApiClient: () => AxiosInstance = () => {
  const client = axios.create({
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  return client;
};

export const apiClient = ApiClient();
